import { SharedPagedRequest } from "@sharedcommon/model/shared-page-request.model";

export class SupplierFilterDto extends SharedPagedRequest {
  inBusinessUnitIds: string[];
  allowedInCustomerCodes: string[];
  inCustomerIds: string[];
  codes: string[];
  label: string;
}